import {
  PLAN_ORDER,
  type BillingCycle,
  type CompliassistPlanId,
} from '../data/plans'
import type { CheckoutStatus } from '../components/checkout-status-dialog'

export interface PricingSearch {
  status?: CheckoutStatus
  plan?: CompliassistPlanId
  cycle?: BillingCycle
}

/** Validates the /pricing search params. Only success|error are kept; plan and
    cycle ride along solely on an error result (they power the dialog's retry). */
export function parsePricingSearch(
  search: Record<string, unknown>,
): PricingSearch {
  const status = search.status
  if (status !== 'success' && status !== 'error') return {}
  if (status === 'success') return { status }

  const plan = PLAN_ORDER.includes(search.plan as CompliassistPlanId)
    ? (search.plan as CompliassistPlanId)
    : undefined
  const cycle =
    search.cycle === 'monthly' || search.cycle === 'yearly'
      ? (search.cycle as BillingCycle)
      : undefined
  return { status, plan, cycle }
}
